import type BookingMeetingType from 'owa-service/lib/contract/BookingService';
import { logUsage } from 'owa-analytics';

import BookingPrivacyType from '../store/schema/BookingPrivacyType';
import { parseMeetingTypeDescription } from '../utils/parseServiceDescription';
import getEntryPoint from './getEntryPoint';
import getMeetingTypes from './getMeetingTypes';
import isDeletedDefaultMeetingType from './isDeletedDefaultMeetingType';
import getFirstTimeUser from './getFirstTimeUser';
import getPageOrigin from './getPageOrigin';

/**
 * Selector function return the list of public and private meeting types
 */
export default function getPrivateAndPublicMeetingTypes() {
    var meetingTypes: BookingMeetingType[] = [];
    const storeMeetingTypes = getMeetingTypes();
    /* eslint-disable-next-line owa-custom-rules/forbid-foreach-with-variables-outside-of-function-scope -- (https://aka.ms/OWALintWiki)
     * https://dev.azure.com/outlookweb/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9650/Use-for-const-loop-of-instead-of-forEach
     *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead */
    storeMeetingTypes.forEach(meetingType => {
        meetingTypes.push(meetingType);
    });

    var publicMeetingTypes: BookingMeetingType[] = [];
    var privateMeetingTypes: BookingMeetingType[] = [];

    meetingTypes.forEach(meetingType => {
        if (meetingType.ExcludeFromSelfService) {
            // Inactive meeting type = private meeting type with no sharing
            !isDeletedDefaultMeetingType(meetingType.ServiceId, true) &&
                privateMeetingTypes.push(meetingType);
        } else {
            // Check meeting type privacy setting
            const meetingTypeDescription = parseMeetingTypeDescription(
                meetingType.Description ?? ''
            );
            if (meetingTypeDescription.privacyType == BookingPrivacyType.PrivateMeetingType) {
                // Invite only meeting type = private meeting type with sharing links
                privateMeetingTypes.push(meetingType);
            } else {
                publicMeetingTypes.push(meetingType);
            }
        }
    });

    logUsage('BwmOrganizerPageVisitedHasAccess', {
        pageOrigin: getPageOrigin(),
        entryPoint: getEntryPoint(),
    });

    logUsage('getMeetingTypeStates', {
        entryPoint: getEntryPoint(),
        public: publicMeetingTypes.length,
        private: privateMeetingTypes.length,
        isNewUser: getFirstTimeUser(),
    });
    return {
        publicMeetingTypes,
        privateMeetingTypes,
    };
}
